const $inject = ['$filter', 'moment', 'lbModalService', 'itinerariesService'];

const lbTripOptionsModalCtrl = function ($filter, moment, lbModalService, itinerariesService) {
  let vm = this;

  vm.itinerary = {};
  vm.searches = {};
  vm.options = [];
  vm.activeOptionIndex = 0;
  vm.form = {};
  vm.saving = false;
  vm.datePickerDateFormat = 'ddd Do MMM, YYYY';
  vm.apiDateFormat = 'YYYY-MM-DD[T]HH:mm:ss';
  vm.displayDateFormat = 'ddd Do MMM, YYYY';
  vm.displayTimeFormat = $filter('translate')('dates.TimeFormatLong');

  vm.prev = prev;
  vm.next = next;
  vm.submit = submit;
  vm.close = close;

  vm.$onInit = () => {
    vm.itinerary = lbModalService.params().itinerary;
    vm.searches.flights = lbModalService.params().flights;

    if(lbModalService.params().hasHotels) {
      vm.options.push('hotel');
      vm.searches.hotels = [];

      _.forEach(vm.searches.flights, (flightSearch, flightSearchIndex) => {
        if(flightSearchIndex < vm.searches.flights.length - 1) {
          vm.searches.hotels.push(hotelSearch(flightSearchIndex, flightSearch, vm.searches.flights[flightSearchIndex + 1]));
        }
      });
    }

    if(lbModalService.params().hasCars) {
      vm.options.push('car');
      vm.searches.cars = [];

      _.forEach(vm.searches.flights, (flightSearch, flightSearchIndex) => {
        if(flightSearchIndex < vm.searches.flights.length - 1) {
          vm.searches.cars.push(carSearch(flightSearchIndex, flightSearch, vm.searches.flights[flightSearchIndex + 1]));
        }
      });
    }
  };

  function hotelSearch(flightSearchIndex, flightSearch, nextFlightSearch) {
    let hotelSearch = {
      isActive: false
    };

    hotelSearch.flight = flightSearch;

    hotelSearch.hotel = {
      key: `hotel${flightSearchIndex}`,
      maxDate: moment().add(330, 'days').format(vm.displayDateFormat),
      minDateFrom: moment(flightSearch.Arrival.Date, vm.apiDateFormat).format(vm.displayDateFormat),
      dateFrom: moment(flightSearch.Arrival.Date, vm.apiDateFormat).format(vm.displayDateFormat),
      dateTo: moment(nextFlightSearch.Departure.Date, vm.apiDateFormat).format(vm.displayDateFormat),
      Location: {
        Title: flightSearch.Arrival.City,
        City: {
          Code: flightSearch.Arrival.Code
        },
        Type: 'Airport',
        Latitude: null,
        Longitude: null
      }
    };

    return hotelSearch;
  }

  function carSearch(flightSearchIndex, flightSearch, nextFlightSearch) {
    let carSearch = {
      isActive: false
    };

    carSearch.flight = flightSearch;

    carSearch.car = {
      key: `car${flightSearchIndex}`,
      pickUp: {
        maxDate: moment().add(330, 'days').format(vm.displayDateFormat),
        minDate: moment(flightSearch.Arrival.Date, vm.apiDateFormat).format(vm.displayDateFormat),
        Date: moment(flightSearch.Arrival.Date, vm.apiDateFormat).format(vm.displayDateFormat),
        Time: nearestValidSearchTime(flightSearch.Arrival.Date),
        Location: {
          Name: flightSearch.Arrival.Location,
          Value: flightSearch.Arrival.Code
        }
      },
      dropOff: {
        maxDate: moment().add(330, 'days').format(vm.displayDateFormat),
        minDate: moment(flightSearch.Arrival.Date, vm.apiDateFormat).add(1, 'days').format(vm.displayDateFormat),
        Date: moment(nextFlightSearch.Departure.Date, vm.apiDateFormat).format(vm.displayDateFormat),
        Time: nearestValidSearchTime(nextFlightSearch.Departure.Date),
        Location: {
          Name: nextFlightSearch.Departure.Location,
          Value: nextFlightSearch.Departure.Code
        }
      }
    };

    return carSearch;
  }

  function nearestValidSearchTime(date) {
    const start = moment(date, vm.apiDateFormat);
    const remainder = 30 - start.minute() % 30;

    return moment(start).add(remainder, 'minutes').format(vm.displayTimeFormat);
  }

  function prev() {
    vm.activeOptionIndex -= 1;
  }

  function next() {
    vm.activeOptionIndex += 1;
  }

  function submit() {
    if (vm.form.$invalid) {
      vm.isDisabled = false;
      return false;
    }

    vm.saving = true;

    let updatedItinerarySearch = angular.copy(itinerariesService.itinerary.Search);
    updatedItinerarySearch.Hotels = buildHotelSearches(vm.searches.hotels);
    updatedItinerarySearch.Cars = buildCarSearches(vm.searches.cars);

    itinerariesService.postSearch(updatedItinerarySearch).then(() => {
      lbModalService.resolve();
    }).finally(() => {
      vm.saving = false;
    });
  }

  function buildHotelSearches(searches) {
    let hotelSearches = [];

    _.forEach(searches, (search) => {
      if (search.isActive) {
        hotelSearches.push({
          DateFrom: moment(search.hotel.dateFrom, vm.displayDateFormat).format(vm.apiDateFormat),
          DateTo: moment(search.hotel.dateTo, vm.displayDateFormat).format(vm.apiDateFormat),
          Location: {
            Code: search.hotel.Location.City.Code,
            Name: search.hotel.Location.Title,
            Type: search.hotel.Location.Type,
            Latitude: search.hotel.Location.Latitude,
            Longitude: search.hotel.Location.Longitude
          }
        });
      }
    });

    return hotelSearches;
  }

  function buildCarSearches(searches) {
    let carSearches = [];

    _.forEach(searches, (search) => {
      if (search.isActive) {
        carSearches.push({
          DropOff: {
            Code: search.car.dropOff.Location.Value,
            Date: moment(`${search.car.dropOff.Date}${search.car.dropOff.Time}`, `${vm.displayDateFormat}${vm.displayTimeFormat}`).format(vm.apiDateFormat),
            Location: search.car.dropOff.Location.Name,
            depot: {}
          },
          PickUp: {
            Code: search.car.pickUp.Location.Value,
            Date: moment(`${search.car.pickUp.Date}${search.car.pickUp.Time}`, `${vm.displayDateFormat}${vm.displayTimeFormat}`).format(vm.apiDateFormat),
            Location: search.car.pickUp.Location.Name,
            depot: {}
          }
        });
      }
    });

    return carSearches;
  }

  function close() {
    lbModalService.reject();
  }
};

lbTripOptionsModalCtrl.$inject = $inject;

export default lbTripOptionsModalCtrl;



// WEBPACK FOOTER //
// ./src/components/lbTripOptionsModal/lbTripOptionsModalCtrl.js